(() => {
    if (window.__customCollectionFiltersAssetInitialized) return;
    window.__customCollectionFiltersAssetInitialized = true;
    const CUSTOM_FILTER_FORM_SELECTOR = '[data-custom-filter-form]';
    const deps = window.MonotomoiCollectionCustomFilterDeps || {};
    const normalizeText = deps.normalizeFilterText || ((value = '') => value.replace(/\s+/g, ' ').trim());
    const sanitizePrice = deps.sanitizePriceFilterValue || ((value = '') => {
        const normalized = normalizeText(value);
        return normalized === '制限なし' ? '' : normalized;
    });
    const buildUrl = deps.buildDirectFilterUrl || ((mutator) => {
        const url = new URL(window.location.href);
        mutator(url.searchParams);
        return url;
    });
    const setAccordionOpen = deps.setCategoryAccordionOpen || (() => {});
    const mobileBreakpoint = deps.mobileBreakpoint || 750;

    function getCustomFilterForms() {
        return Array.from(document.querySelectorAll(CUSTOM_FILTER_FORM_SELECTOR));
    }

    function getPriceRanges(form) {
        if (!form) return [];

        if (form.dataset.filterType === 'price_range') {
            return [{
                filterLabel: form.dataset.filterLabel || '',
                minParam: form.dataset.minParam,
                maxParam: form.dataset.maxParam,
                minInput: form.elements[form.dataset.minParam],
                maxInput: form.elements[form.dataset.maxParam]
            }];
        }

        return Array.from(form.querySelectorAll('[data-price-range-params]')).map((wrapper) => ({
            filterLabel: wrapper.dataset.filterLabel || normalizeText(wrapper.closest('.accordion')?.querySelector('.accordion__toggle span:first-child')?.textContent || ''),
            minParam: wrapper.dataset.minParam,
            maxParam: wrapper.dataset.maxParam,
            minInput: wrapper.querySelector(`input[name="${CSS.escape(wrapper.dataset.minParam || '')}"]`),
            maxInput: wrapper.querySelector(`input[name="${CSS.escape(wrapper.dataset.maxParam || '')}"]`)
        }));
    }

    function getCategorySubmissionState(form) {
        const large = new Set();
        const middle = [];

        form.querySelectorAll('input[data-category-level="large"]:checked').forEach((largeInput) => {
            large.add(largeInput.value);
        });

        form.querySelectorAll('input[data-category-level="middle"]:checked').forEach((middleInput) => {
            middle.push(middleInput.value);

            if (middleInput.dataset.categoryParentValue) {
                large.add(middleInput.dataset.categoryParentValue);
            }
        });

        return {
            large: Array.from(large),
            middle
        };
    }

    function syncCategoryCheckboxTree(form) {
        if (!form) return;

        form.querySelectorAll('input[data-category-level="large"]').forEach((largeInput) => {
            const title = largeInput.closest('.title');
            const panel = title?.nextElementSibling;

            if (!panel) return;

            const middleInputs = panel.querySelectorAll('input[data-category-level="middle"]');
            if (middleInputs.length === 0) return;

            const anyChecked = Array.from(middleInputs).some((input) => input.checked);
            const allChecked = Array.from(middleInputs).every((input) => input.checked);

            if (anyChecked) {
                largeInput.checked = true;
                largeInput.indeterminate = !allChecked;
                return;
            }

            largeInput.indeterminate = false;
        });
    }

    function bindCategoryLevelInputs(form) {
        if (!form || form._customCategoryBound) return;

        form.querySelectorAll('input[data-category-level="large"]').forEach((largeInput) => {
            largeInput.addEventListener('change', () => {
                const title = largeInput.closest('.title');
                const panel = title?.nextElementSibling;
                if (!panel) return;

                largeInput.indeterminate = false;
                panel.querySelectorAll('input[name="filter.p.m.custom._category2"]').forEach((middleInput) => {
                    middleInput.checked = largeInput.checked;
                });

                if ((window.innerWidth < mobileBreakpoint || form.dataset.accordionCollapsible === 'true') && title) {
                    setAccordionOpen(title, largeInput.checked, form);
                }
            });
        });

        form.querySelectorAll('input[name="filter.p.m.custom._category2"]').forEach((middleInput) => {
            middleInput.addEventListener('change', () => {
                const panel = middleInput.closest('.unit');
                const title = panel?.previousElementSibling;
                const largeInput = title?.querySelector('input[data-category-level="large"]');
                if (!title || !largeInput) return;

                const siblingInputs = panel.querySelectorAll('input[name="filter.p.m.custom._category2"]');
                const anyChecked = Array.from(siblingInputs).some((input) => input.checked);
                const allChecked = Array.from(siblingInputs).every((input) => input.checked);

                largeInput.checked = anyChecked;
                largeInput.indeterminate = anyChecked && !allChecked;

                if (window.innerWidth < mobileBreakpoint || form.dataset.accordionCollapsible === 'true') {
                    setAccordionOpen(title, true, form);
                }
            });
        });

        form._customCategoryBound = true;
    }

    function applyFilters(form) {
        const url = buildUrl((params) => {
            params.delete('page');
            params.delete('client_page');

            const paramNames = [...new Set(
                Array.from(form.querySelectorAll('input[type="checkbox"]'))
                    .map((input) => input.name)
                    .filter(Boolean)
            )];

            paramNames.forEach((name) => params.delete(name));

            form.querySelectorAll('input[type="checkbox"]:checked').forEach((input) => {
                if (input.dataset.categoryLevel) return;
                params.append(input.name, input.value);
            });

            const submissionState = getCategorySubmissionState(form);
            submissionState.large.forEach((value) => {
                params.append('filter.p.m.custom._category1', value);
            });
            submissionState.middle.forEach((value) => {
                params.append('filter.p.m.custom._category2', value);
            });

            getPriceRanges(form).forEach(({ minParam, maxParam, minInput, maxInput }) => {
                const minValue = sanitizePrice(minInput?.value || '');
                const maxValue = sanitizePrice(maxInput?.value || '');

                if (minParam) params.delete(minParam);
                if (maxParam) params.delete(maxParam);

                if (minParam && minValue) params.set(minParam, minValue);
                if (maxParam && maxValue) params.set(maxParam, maxValue);
            });
        });

        window.location.href = url.toString();
    }

    function resetFilters(form) {
        form.querySelectorAll('input[type="checkbox"]').forEach((input) => {
            input.checked = false;
        });

        getPriceRanges(form).forEach(({ minInput, maxInput }) => {
            if (minInput) minInput.value = '';
            if (maxInput) maxInput.value = '';
        });

        applyFilters(form);
    }

    function bindForms() {
        getCustomFilterForms().forEach((form) => {
            if (form._customFilterBound) return;

            bindCategoryLevelInputs(form);

            form.addEventListener('submit', (event) => {
                event.preventDefault();
                applyFilters(form);
            });

            const drawerFooterButtons = Array.from(document.querySelectorAll(`button[form="${form.id}"][name="custom-filter-submit"]`));
            drawerFooterButtons.forEach((button) => {
                if (button._customFilterSubmitBound) return;
                button.addEventListener('click', () => applyFilters(form));
                button._customFilterSubmitBound = true;
            });

            if (form.dataset.autoSubmit === 'true') {
                const autoSubmit = () => {
                    clearTimeout(form._autoSubmitTimer);
                    form._autoSubmitTimer = setTimeout(() => applyFilters(form), 250);
                };

                form.querySelectorAll('input[type="checkbox"]').forEach((input) => {
                    input.addEventListener('change', autoSubmit);
                });

                getPriceRanges(form).forEach(({ minInput, maxInput }) => {
                    minInput?.addEventListener('change', autoSubmit);
                    maxInput?.addEventListener('change', autoSubmit);
                });
            }

            form.querySelector('.active-button')?.addEventListener('click', () => applyFilters(form));
            form.querySelector('.reset-button')?.addEventListener('click', () => resetFilters(form));

            form._customFilterBound = true;
        });
    }

    function initPriceSelectWrappers() {
        document.querySelectorAll('.price-select-wrapper').forEach((wrapper) => {
            if (wrapper._customPriceWrapperBound) return;

            const input = wrapper.querySelector('.price-input');
            const dropdown = wrapper.querySelector('.custom-dropdown');

            if (!input || !dropdown) {
                wrapper._customPriceWrapperBound = true;
                return;
            }

            input.addEventListener('click', (event) => {
                event.stopPropagation();

                document.querySelectorAll('.custom-dropdown').forEach((currentDropdown) => {
                    if (currentDropdown !== dropdown) {
                        currentDropdown.style.display = 'none';
                    }
                });

                dropdown.style.display = dropdown.style.display === 'block' ? 'none' : 'block';
            });

            dropdown.querySelectorAll('.option').forEach((option) => {
                option.addEventListener('click', () => {
                    input.value = option.textContent.trim();
                    dropdown.style.display = 'none';
                });
            });

            wrapper._customPriceWrapperBound = true;
        });

        if (document._customPriceSelectWrapperBound) return;

        document.addEventListener('click', (event) => {
            document.querySelectorAll('.price-select-wrapper').forEach((wrapper) => {
                if (!wrapper.contains(event.target)) {
                    wrapper.querySelector('.custom-dropdown')?.style.setProperty('display', 'none');
                }
            });
        });

        document._customPriceSelectWrapperBound = true;
    }

    function restore() {
        const params = new URLSearchParams(window.location.search);

        getCustomFilterForms().forEach((form) => {
            form.querySelectorAll('input[type="checkbox"]').forEach((input) => {
                input.checked = params.getAll(input.name).includes(input.value);
            });

            getPriceRanges(form).forEach(({ minParam, maxParam, minInput, maxInput }) => {
                if (minInput && minParam) minInput.value = params.get(minParam) || '';
                if (maxInput && maxParam) maxInput.value = params.get(maxParam) || '';
            });

            syncCategoryCheckboxTree(form);
        });
    }

    async function syncCategoryCounts() {
        const currentUrl = new URL(window.location.href);
        const hasActiveCategoryFilters = currentUrl.searchParams.getAll('filter.p.m.custom._category1').length > 0
            || currentUrl.searchParams.getAll('filter.p.m.custom._category2').length > 0;

        const largeCounts = new Map();
        const middleCounts = new Map();

        const collectCounts = (root) => {
            root.querySelectorAll('input[data-category-level="large"]').forEach((input) => {
                const countNode = input.closest('.title, label')?.querySelector('[data-category-count]');
                if (!countNode) return;
                const match = countNode.textContent.match(/\d+/);
                largeCounts.set(input.value, match ? Number(match[0]) : 0);
            });

            root.querySelectorAll('input[data-category-level="middle"]').forEach((input) => {
                const countNode = input.closest('label')?.querySelector('[data-category-count]');
                if (!countNode) return;
                const match = countNode.textContent.match(/\d+/);
                middleCounts.set(input.value, match ? Number(match[0]) : 0);
            });
        };

        if (hasActiveCategoryFilters) {
            const countsUrl = new URL(currentUrl);
            countsUrl.searchParams.delete('filter.p.m.custom._category1');
            countsUrl.searchParams.delete('filter.p.m.custom._category2');
            countsUrl.searchParams.delete('page');
            countsUrl.searchParams.delete('client_page');

            try {
                const response = await fetch(countsUrl.toString(), { credentials: 'same-origin' });
                if (response.ok) {
                    const html = await response.text();
                    const doc = new DOMParser().parseFromString(html, 'text/html');
                    collectCounts(doc);
                }
            } catch (error) {
                console.warn('Failed to refresh category counts without category params.', error);
            }
        }

        if (largeCounts.size === 0 && middleCounts.size === 0) {
            collectCounts(document);
        }

        document.querySelectorAll(`${CUSTOM_FILTER_FORM_SELECTOR}, .custom-filter-sidebar`).forEach((root) => {
            root.querySelectorAll('input[data-category-level="large"]').forEach((input) => {
                const countNode = input.closest('.title, label')?.querySelector('[data-category-count]');
                if (!countNode) return;
                countNode.textContent = `(${largeCounts.get(input.value) || 0})`;
            });

            root.querySelectorAll('input[data-category-level="middle"]').forEach((input) => {
                const countNode = input.closest('label')?.querySelector('[data-category-count]');
                if (!countNode) return;
                countNode.textContent = `(${middleCounts.get(input.value) || 0})`;
            });
        });
    }

    function init() {
        restore();
        bindForms();
        initPriceSelectWrappers();
        syncCategoryCounts();
    }

    window.MonotomoiCustomCollectionFilters = {
        getPriceRanges,
        init,
        restore,
        syncCategoryCounts
    };
})();
